class SliderInstance {
	constructor(sliderElement) {
		this.sliderElement = sliderElement;
		this.swiper = null;
		this.autoplayInterval = null;
		this.isUserInteracting = false;
		this.activeSlide = 0;
		this.isMobile = false;
		
		this.init();
	}
	
	init() {
		this.initializeSwiper();
		this.bindResize();
	}
	
	// Check if we're on mobile/tablet - use CSS media query to match exactly
	checkMobile() {
		return window.matchMedia('(max-width: 1199px)').matches;
	}
	
	// Initialize Swiper based on screen size
	initializeSwiper() {
		this.isMobile = this.checkMobile();
		
		if (this.swiper) {
			this.swiper.destroy(true, true);
			this.swiper = null;
		}
		
		// Check both containers within this slider instance
		const desktopContainer = this.sliderElement.querySelector('.slider-images .swiper');
		const mobileContainer = this.sliderElement.querySelector('.slider-images-mobile .swiper');
		
		const swiperContainer = this.isMobile ? mobileContainer : desktopContainer;
				
		if (!swiperContainer) {
			return;
		}
		
		if (this.isMobile) {
			// Mobile configuration: full slider with touch/swipe
			this.swiper = new Swiper(swiperContainer, {
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				speed: 600,
				allowTouchMove: true,
				loop: false,
				autoplay: {
					delay: 4000,
					disableOnInteraction: false,
					pauseOnMouseEnter: false
				},
				pagination: {
					el: swiperContainer.querySelector('.swiper-pagination'),
					clickable: true,
					type: 'bullets'
				},
				on: {
					init: () => {
						//console.log('Mobile swiper initialized');
					}
				}
			});
		} else {
			// Desktop configuration: fade effect, no touch
			this.swiper = new Swiper(swiperContainer, {
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				speed: 600,
				allowTouchMove: false,
				loop: false,
				autoplay: false,
				on: {
					init: () => {
						console.log('Desktop swiper initialized');
					}
				}
			});
			
			// Listen to slide change events for desktop
			this.swiper.on('slideChange', () => {
				this.activeSlide = this.swiper.activeIndex;
				this.updateActiveColumn();
			});
			
			// Add hover events to columns for desktop
			const columns = this.sliderElement.querySelectorAll('.slider-column');
			columns.forEach((column, index) => {
				column.addEventListener('mouseenter', () => {
					this.onHover(index);
				});
				
				column.addEventListener('mouseleave', () => {
					this.onLeave();
				});
			});
			
			// Start autoplay for desktop
			this.startAutoplay();
		}
	}
	
	// Desktop hover functions
	onHover(index) {
		if (this.isMobile) return;
		this.isUserInteracting = true;
		this.stopAutoplay();
		this.goToSlide(index);
	}
	
	onLeave() {
		if (this.isMobile) return;
		this.isUserInteracting = false;
		setTimeout(() => {
			if (!this.isUserInteracting) {
				this.startAutoplay();
			}
		}, 1000);
	}
	
	goToSlide(index) {
		if (this.swiper && this.activeSlide !== index) {
			this.swiper.slideTo(index);
		}
	}
	
	updateActiveColumn() {
		if (this.isMobile) return;
		const columns = this.sliderElement.querySelectorAll('.slider-column');
		columns.forEach((column, index) => {
			column.classList.toggle('active', index === this.activeSlide);
		});
	}
	
	startAutoplay() {
		if (this.isMobile) return; // Mobile uses built-in Swiper autoplay
		this.stopAutoplay();
		const columns = this.sliderElement.querySelectorAll('.slider-column');
		
		this.autoplayInterval = setInterval(() => {
			if (!this.isUserInteracting && this.swiper) {
				const nextIndex = (this.activeSlide + 1) % columns.length;
				this.goToSlide(nextIndex);
			}
		}, 4000);
	}
	
	stopAutoplay() {
		if (this.autoplayInterval) {
			clearInterval(this.autoplayInterval);
			this.autoplayInterval = null;
		}
	}
	
	bindResize() {
		let resizeTimeout;
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(() => {
				const newIsMobile = this.checkMobile();
				if (newIsMobile !== this.isMobile) {
					this.initializeSwiper();
				}
			}, 250);
		});
	}
	
	destroy() {
		if (this.swiper) {
			this.swiper.destroy(true, true);
		}
		this.stopAutoplay();
	}
}

// Initialize all sliders on the page
export function initSlider() {
	const sliderElements = document.querySelectorAll('.hero-slider');
	const sliderInstances = [];
	
	sliderElements.forEach(sliderElement => {
		const instance = new SliderInstance(sliderElement);
		sliderInstances.push(instance);
	});
	
	return sliderInstances;
}
